import { useEffect, useRef, useState } from 'react'

import type { Audience, Budget, Campaign, Market, Objective } from '../../demo/types'
import { Button, Modal } from '../../ui'
import { AudiencePicker } from '../create/AudiencePicker'
import { BudgetField } from '../create/BudgetField'
import { MarketPicker } from '../create/MarketPicker'
import { ObjectivePicker } from '../create/ObjectivePicker'
import styles from './TaskDetailPage.module.css'

interface EditSettingsDialogProps {
  open: boolean
  focusAudience: boolean
  campaign: Campaign
  onClose: () => void
  onSave: (patch: { objective: Objective; markets: Market[]; audience: Audience; budget: Budget }) => void
}

export function EditSettingsDialog({ open, focusAudience, campaign, onClose, onSave }: EditSettingsDialogProps) {
  const [objective, setObjective] = useState(campaign.objective)
  const [markets, setMarkets] = useState(campaign.markets)
  const [audience, setAudience] = useState(campaign.audience)
  const [budget, setBudget] = useState(campaign.budget)
  const audienceRef = useRef<HTMLElement>(null)
  useEffect(() => {
    if (focusAudience) window.setTimeout(() => audienceRef.current?.scrollIntoView({ block: 'center' }), 0)
  }, [focusAudience])
  return (
    <Modal open={open} title="编辑设置" hint="调整后将同步更新广告任务" onClose={onClose} footer={<><Button variant="ghost" onClick={onClose}>取消</Button><Button onClick={() => onSave({ objective, markets, audience, budget })}>保存设置</Button></>}>
      <div className={styles.settingsBody}>
        <ObjectivePicker value={objective} onChange={setObjective} />
        <MarketPicker value={markets} onChange={setMarkets} />
        <AudiencePicker value={audience} onChange={setAudience} sectionRef={audienceRef} />
        <BudgetField value={budget} onChange={setBudget} />
      </div>
    </Modal>
  )
}
